module.exports = __webpack_public_path__ + "static/media/balance-board.f02efff3.jpg";